// ReadOnlyValue — the read-only counterpart of an Input/Select in the channel
// connect panels. It exists so "absent, not disabled" is one shape everywhere
// instead of four hand-rolled label/value pairs: a read-only caller sees what
// the field HOLDS, not a control they can type into and never submit.
//
// The pattern originates in SettingsTab's read-only arm — no <form>, no
// editable control, plain text — and is the presentation the OH-41 fix wave
// settled on. See OH-52 for why the connect panels were brought in line.
export function ReadOnlyValue({
  label,
  value,
  empty = '—',
}: {
  label: string;
  value: string | null | undefined;
  empty?: string;
}) {
  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.06em] text-muted">{label}</p>
      <p className="mt-1 break-words text-sm">{value?.trim() ? value : empty}</p>
    </div>
  );
}
